var _Checkmark;
import cn from 'classnames';
import Checkmark from '@crehana/icons/outline/Checkmark';
import parseClassnames from "../helpers/parseClassnames";
import transition from "../styles/transition";
import { jsx as _jsx } from "react/jsx-runtime";
var Adornment = function Adornment(_ref) {
  var type = _ref.type,
    startAdornment = _ref.startAdornment,
    endAdornment = _ref.endAdornment,
    adornmentClassNames = _ref.adornmentClassNames,
    chat = _ref.chat,
    multirow = _ref.multirow;
  var element = startAdornment;
  if (type === 'end') {
    element = endAdornment;
  } else if (type === 'check') {
    element = _Checkmark || (_Checkmark = /*#__PURE__*/_jsx(Checkmark, {
      className: "fill-current text-green-main",
      size: 24,
      ignoreColor: true
    }));
  }
  return /*#__PURE__*/_jsx("div", {
    className: parseClassnames(adornmentClassNames ? adornmentClassNames[type] || '' : '', cn('flex items-center', type === 'start' ? 'pl-16' : 'pr-16', chat || multirow ? 'h-40' : 'h-56', {
      'pb-16': multirow
    })),
    style: {
      transition: transition(['padding', 'height'])
    },
    children: element
  });
};
export default Adornment;